import { Component } from "@angular/core";
import { RootScope } from "./commons/services/rootScope.service";
import { toSignal } from "@angular/core/rxjs-interop";

@Component({
    selector: 'ng-app',
    templateUrl: "./app.component.html",
    standalone: false
})
export class NgApp {

  protected _pageLoading = toSignal(this.rootScope.pageLoadingChange);
  protected _pageLoaded = toSignal(this.rootScope.pageLoadedChange);
  protected _appInitialized = toSignal(this.rootScope.appInitializedChange);

  constructor(
    private rootScope: RootScope,
  ) { }
}
